import { z } from 'zod'

export const ManagementTypeSchema = z.enum(['platform', 'standalone'])

export const TenantStatusSchema = z.enum(['active', 'inactive', 'planned'])

export const TenantSchema = z.object({
  id: z.string(),
  name: z.string(),
  managementType: ManagementTypeSchema,
  status: TenantStatusSchema,
  subdomain: z.string(),
  externalId: z.string().nullable(),
  customerNumber: z.string().nullable(),
  currencyCode: z.string().optional(),
  languageCode: z.string(),
  demo: z.boolean(),
  provisionDate: z.string(),
})

export const TenantListResponseSchema = z.object({
  count: z.number(),
  next: z.string().nullable(),
  previous: z.string().nullable(),
  results: z.array(TenantSchema),
})
